(function() {
	angular
		.module('main')
		.controller('CompanyUsersController', CompanyUsersController);

	CompanyUsersController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'messageService',
		'validationService',
		'accountService',
		'companySettingsService'
	];

	function CompanyUsersController(
		$scope,
		$rootScope,
		$http,
		messageService,
		validationService,
		accountService,
		companySettingsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			delete $rootScope.error;
			$scope.getUsers();
			getUser();
			$scope.isSendInviteSpinnningWheelActive = false;
			$scope.isDeleteUserSpinnningWheelActive = false;
			$scope.isEditUserSpinnningWheelActive = false;
		});

		$scope.$on('$destroy', () => {
			$scope.userObservable.unsubscribe();
		});

		$scope.showInvite = function() {
			$('#invite')
				.modal('show')
				.on('shown.bs.modal', function() {
					const input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
		};
		$scope.getUsers = function() {
			$http({
				method: 'GET',
				url: '/protected/rest/company/users'
			})
				.then(result => {
					const data = result.data;
					if (data) {
						$scope.company = data;
						$scope.users = data.users;
						$scope.companyName = data.name;
					} else {
						console.error('No company data');
					}
				})
				.catch(messageService.showDefaultErrorMessage);
		};

		$scope.checkInvite = function() {
			if ($scope.item && ($scope.item.name || $scope.item.email)) {
				if (!$scope.item.name) {
					return messageService.showToaster('e_0', 'companyUsers');
				}
				if (!$scope.item.email) {
					return messageService.showToaster('e_2', 'companyUsers');
				}
				const x = $scope.item.email;
				const atpos = x.indexOf('@');
				const dotpos = x.lastIndexOf('.');
				if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= x.length) {
					return messageService.showToaster('e_3', 'companyUsers');
				}
			} else {
				return messageService.showToaster('e_1', 'companyUsers');
			}

			if ($scope.user.inTrial) {
				$('#invite')
					.modal('hide')
					.on('hidden.bs.modal', function() {
						// $('#inviteWarning').modal('show');
						$(this).off('hidden.bs.modal');
					});

				$scope.invite();
			} else {
				$scope.invite();
			}
		};
		$scope.invite = function() {
			$scope.isSendInviteSpinnningWheelActive = true;
			$scope.button_disable = true;
			$http({
				method: 'POST',
				url: '/protected/rest/users/invite',
				data: $scope.item
			})
				.then(result => successInviteCompanyUser(result.data))
				.catch(result => errorInviteCompanyUser(result.data))
				.finally(() => {
					$scope.button_disable = false;
					$scope.isSendInviteSpinnningWheelActive = false;
				});
		};

		function getUser() {
			$scope.userObservable = accountService.userDataObservable.subscribe(
				user => {
					if (user !== null && typeof user !== 'undefined') {
						$scope.user = JSON.parse(JSON.stringify(user));
					}
				}
			);
		}

		function successInviteCompanyUser(data) {
			let isRegisteredUser;

			if (data && data.message) {
				isRegisteredUser = data.message
					.toLowerCase()
					.includes('user already registered');
			}

			if (isRegisteredUser) {
				return messageService.showToaster(
					'e_4',
					'companyUsers',
					$scope.item.email
				);
			}

			if (!data || !isRegisteredUser) {
				messageService.showToaster('i_0', 'companyUsers', $scope.item.email);
				$scope.userActionResult = data;
				$('#invite').modal('hide');
				$('#inviteWarning').modal('hide');
				delete $scope.item;
			}
		}

		function errorInviteCompanyUser(data) {
			let isRegisteredUser;

			if (data && data.message) {
				isRegisteredUser = data.message
					.toLowerCase()
					.includes('user already registered');
			}

			if (isRegisteredUser) {
				return messageService.showToaster(
					'e_4',
					'companyUsers',
					$scope.item.email
				);
			}

			messageService.showToaster('e_0', 'general');
		}

		$scope.showDeleteModal = function(index) {
			$scope.deletedUser = angular.copy($scope.users[index]);
			$('#deleteModal').modal('show');
		};

		$scope.editUser = function(index) {
			$scope.editedUser = angular.copy($scope.users[index]);
			$('#edit')
				.modal('show')
				.on('shown.bs.modal', function() {
					const input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
		};

		$scope.deleteUser = function() {
			$scope.isDeleteUserSpinnningWheelActive = true;
			companySettingsService
				.deleteUser($scope.deletedUser.id)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isDeleteUserSpinnningWheelActive = false;
				})
				.subscribe(
					result => successDeleteUser(result.data),
					error => errorDeleteUser(error)
				);
		};

		function successDeleteUser(data) {
			if (!data) {
				messageService.showToaster(
					's_1',
					'companyUsers',
					$scope.deletedUser.email
				);
				$('#deleteModal').modal('hide');
				$scope.getUsers();
			} else if (data && data.errorMessage) {
				closeModalAndShowError('#deleteModal', errorMessage);
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		function errorDeleteUser(result) {
			const { errorCode, errorMessage } = result.error;

			if (errorCode && errorMessage) {
				closeModalAndShowError('#deleteModal', errorMessage);
			} else {
				messageService.showDefaultErrorMessage(result);
			}
		}

		function closeModalAndShowError(modalToClose, errorMessage) {
			$(modalToClose)
				.modal('hide')
				.on('hidden.bs.modal', function() {
					$scope.clientDeleteErrorMessage = errorMessage;
					$('#errorMessageModal').modal('show');
					$(this).off('hidden.bs.modal');
				});
		}

		$scope.checkEdit = function() {
			if (!$scope.editedUser.firstName) {
				return messageService.showToaster('e_0', 'companyUsers');
			}
			$scope.saveEditChanges();
		};

		$scope.saveEditChanges = function() {
			$scope.button_disable = true;
			$scope.isEditUserSpinnningWheelActive = true;

			$http({
				method: 'POST',
				url: '/protected/rest/company/user/edit',
				data: $scope.editedUser
			})
				.then(
					result => {
						$scope.button_disable = false;
						if (result.data) {
							messageService.showToaster(
								's_0',
								'companyUsers',
								$scope.editedUser.email
							);
							$('#edit').modal('hide');
							$scope.getUsers();
						}
					},
					() => {
						messageService.showToaster('e_0', 'general');
					}
				)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isEditUserSpinnningWheelActive = false;
				});
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/companyUsersController.js